import { Button, Input } from "@ancatag/at-design";
import type { ChangeEvent, FormEvent } from "react";
import { useState } from "react";
import { useLocation } from "wouter";
import { apiFetch } from "../../services/apiFetch";

interface SignupProps {
	onLoginClick?: () => void;
}

export function Signup({ onLoginClick }: SignupProps) {
	const [, navigate] = useLocation();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [name, setName] = useState("");
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState<string | null>(null);
	const [error, setError] = useState<string | null>(null);

	const handleLoginClick = () => {
		if (onLoginClick) {
			onLoginClick();
		} else {
			navigate("/login");
		}
	};

	const handleSignup = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setLoading(true);
		setMessage(null);
		setError(null);
		try {
			await apiFetch("/auth/signup", {
				method: "POST",
				body: JSON.stringify({
					email,
					password,
					name,
				}),
			});

			setMessage("Signup successful! You can now sign in.");
			setTimeout(() => {
				navigate("/login");
			}, 2000);
		} catch (err) {
			const errorMessage =
				err instanceof Error ? err.message : "Signup failed. Please try again.";
			setError(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	return (
		<form onSubmit={handleSignup} className="space-y-4">
			<Input
				type="text"
				placeholder="Full Name"
				value={name}
				onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
				required
			/>
			<Input
				type="email"
				placeholder="Email"
				value={email}
				onChange={(e: ChangeEvent<HTMLInputElement>) =>
					setEmail(e.target.value)
				}
				required
			/>
			<Input
				type="password"
				placeholder="Password"
				value={password}
				onChange={(e: ChangeEvent<HTMLInputElement>) =>
					setPassword(e.target.value)
				}
				required
			/>
			<Button type="submit" className="w-full" disabled={loading}>
				{loading ? "Signing up..." : "Sign Up"}
			</Button>
			{message && (
				<div className="mt-4 p-3 bg-green-50 text-green-700 rounded text-center text-sm">
					{message}
				</div>
			)}
			{error && (
				<div className="mt-4 p-3 bg-red-50 text-red-700 rounded text-center text-sm">
					{error}
				</div>
			)}
			<div className="mt-6 text-center text-sm text-muted-foreground">
				Already have an account?{" "}
				<button
					type="button"
					className="text-primary underline cursor-pointer hover:text-primary/80 transition-colors"
					onClick={handleLoginClick}
				>
					Sign in
				</button>
			</div>
		</form>
	);
}
